export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#0A1628] to-[#1E3A5F] text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-4 gap-12 mb-12">
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/6e8e447b-345b-4045-8ebb-50f9e52f5ebf.png" 
                alt="J. N. DOS S. MELO LTDA Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-white font-semibold text-lg whitespace-nowrap">J. N. DOS S. MELO LTDA</span>
            </div>
            <p className="text-[#B8C5D6] text-base leading-relaxed max-w-md">
              Protecting your digital privacy with enterprise-grade VPN technology. Secure, fast, and reliable internet connection for everyone.
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4 whitespace-nowrap">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base whitespace-nowrap">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base whitespace-nowrap">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base whitespace-nowrap">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base whitespace-nowrap">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4 whitespace-nowrap">Contact Info</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@jndossmeloltda.com" className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span className="whitespace-nowrap">Email Us</span>
                </a>
              </li>
              <li>
                <a href="tel:+15866660942" className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-base flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span className="whitespace-nowrap">Call Us</span>
                </a>
              </li>
              <li className="text-[#B8C5D6] text-base flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>IPIRANGA DO NORTE, Brazil</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-[#B8C5D6] text-sm">
              © 2025 J. N. DOS S. MELO LTDA. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#B8C5D6] hover:text-[#00D9FF] transition-colors text-sm whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
